import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaginatorComponent } from './components/paginator/paginator.component';

import { McRAIButtonModule } from '../button/button.module';
import { McRAIIconModule } from '../icon/icon.module';

@NgModule({
  imports: [
    CommonModule,
    McRAIButtonModule,
    McRAIIconModule
  ],
  declarations: [
    PaginatorComponent
  ],
  exports: [
    PaginatorComponent
  ]
})
export class McRAIPaginatorModule { }
